<template>
  <el-form-item v-bind="$attrs" :label="itemName" v-if="display" :error="error">
    <!-- input -->
    <el-input v-if="is('input')" v-model="val" v-bind="option"></el-input>
    <!-- select -->
    <el-select
      v-if="is('select') || is('multiple')"
      v-model="val"
      v-bind="option"
      :multiple="is('multiple')"
    >
      <el-option
        v-for="e in itemList"
        :key="e[1]"
        :disbled="validVal(e[2], false)"
        :label="e[0]"
        :value="e[1]"
      ></el-option>
    </el-select>
    <!-- radio -->
    <el-radio-group v-if="is('radio')" v-model="val" v-bind="option">
      <el-radio v-for="e in itemList" :key="e[1]" :disbled="validVal(e[2], false)" :label="e[1]">
        {{ e[0] }}
      </el-radio>
    </el-radio-group>
    <!-- checkbox -->
    <el-checkbox-group v-if="is('checkbox')" v-model="sval" v-bind="option">
      <el-checkbox v-for="e in itemList" :key="e[1]" :disbled="validVal(e[2], false)" :label="e[1]">
        {{ e[0] }}
      </el-checkbox>
    </el-checkbox-group>
    <!-- switch -->
    <el-switch
      v-if="is('switch')"
      :value="!!val"
      @change="e => (val = +e)"
      v-bind="option"
    ></el-switch>
  </el-form-item>
</template>

<script>
import { validVal, adaptorProps, validator, makeRules } from './utils';

export default {
  props: {
    itemName: String, // label
    value: [String, Number, Array, Boolean], // 值
    defValue: [String, Number, Array, Boolean], // 默认值
    itemCode: String, // 属性名
    disabled: Boolean, // 是否可编辑
    max: Number, // 数值最大值
    min: Number, // 数值最小值
    maxlLength: Number, // 可输入最大长度
    precision: Number, // 数值精度
    placeholder: String,
    /** 值类型 */
    itemType: {
      validator(v) {
        return validator.valType(v);
      }
    },
    /** 元素尺寸 */
    size: {
      validator(v) {
        return validator.size(v);
      }
    },
    /** 元素类型 */
    displayType: {
      validator(v) {
        return validator.elType(v);
      },
      default: 'input'
    },
    /** select checkbox radio选择列表 [[label,value, disabled]] */
    itemList: {
      type: Array,
      default: () => []
    },
    /** 是否显示 */
    display: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      i18nPath: 'component.deviceParamDialog',
      error: '',
      rule: makeRules(this)
    };
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(v) {
        v = typeof v === 'string' ? v.trim() : v;
        this.$emit('input', v);
      }
    },
    sval: {
      get() {
        if (this.displayType !== 'checkbox') return null;
        return this.val.split(',');
      },
      set(v) {
        this.val = v.join(',');
      }
    },
    option() {
      return this.adOption(this.displayType);
    }
  },
  methods: {
    validVal,
    is(type) {
      return this.displayType === type;
    },
    adOption(elType) {
      return adaptorProps(elType, this);
    },
    getValType() {
      return typeof this.itemList[0][1];
    },
    checkboxChange(e) {
      this.val = e.join(',');
    }
  },
  watch: {
    val(v) {
      this.rule &&
        this.rule(null, v, err => {
          this.error = err ? err.message : '';
        });
    }
  }
};
</script>
